import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import EHttpStatusCodes from 'enums/httpStatusCodes';
import { call, put } from 'redux-saga/effects';

import httpClient from 'services/httpClient/index';
import IGetAllProductRequest from 'services/httpClient/request/product/IGetAllProductRequest';
import IGetAllProductResponse from 'services/httpClient/responses/product/IGetAllProductResponse';

import { productActions } from '../index';
import { IGetAllProductRequestAction } from '../reducers/getAll/request';

function* getAll(action: PayloadAction<IGetAllProductRequestAction>) {
  try {
    const params: IGetAllProductRequest = {
      barcode: action.payload.data.ean || undefined,
      manufacturer: action.payload.data.manufacturer || undefined,
      name: action.payload.data.description || undefined,
      page: action.payload.data.page,
      sku: action.payload.data.sku || undefined,
    };
    const response: AxiosResponse<IGetAllProductResponse> = yield call(
      httpClient.get,
      'admins/products',
      { params },
    );
    if (response.status === EHttpStatusCodes.NO_CONTENT) {
      yield put(
        productActions.getAllSuccessWithoutData({
          message: 'Nenhum produto encontrado',
        }),
      );
      return;
    }
    yield put(
      productActions.getAllSuccessWithData({
        list: response.data.list,
        totalPages: response.data.totalPages || 1,
      }),
    );
  } catch (err) {
    action.payload.functions.error(err);
    yield put(productActions.getAllFailure());
  }
}

export default getAll;
